import { Component, ElementRef, Input, Renderer2 } from '@angular/core'

export interface ITab {
  title: string
  isActive: boolean
}

/**
 * @deprecated Use `flo-nav` or `flo-tabs` instead
 */
@Component({
  selector: 'flo-live-tab',
  styleUrls: ['./tab.component.scss'],
  template: '<div><ng-content></ng-content></div>'
})
export class TabComponent implements ITab {
  @Input() title: string
  @Input() isActive = false

  constructor(public elementRef: ElementRef<HTMLElement>, public renderer: Renderer2) {}
}
